(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["i18nComponent"] = factory();
	else
		root["i18nComponent"] = root["i18nComponent"] || {}, root["i18nComponent"]["input-number"] = factory();
})(self, function() {
return 